import { render, staticRenderFns } from "./WorkDocsWorkAreaTableItem.vue?vue&type=template&id=6fab8350&"
import script from "./WorkDocsWorkAreaTableItem.vue?vue&type=script&lang=js&"
export * from "./WorkDocsWorkAreaTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports